import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate";
import { LabelPdf } from "@/modules/TemplatePdf/Models/labelsPdf";
import {
  EMIT_ACTION_PLAN_TEMPLATE_EVENTS,
  LABELS_ADD_ACTIONPLAN_FORM,
  LABELS_DATATYPE
} from "../../../constants/TemplatePdfConstants";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";

Vue.use(Vuetify);
@Component({
  name: "AddLabelActionPlan",
  components: {
    ModalTemplate
  }
})
export default class AddLabelActionPlan extends Vue {
  @Prop() isModal!: boolean;
  @Prop() labelShowList!: LabelPdf[];
  LABEL_DATATYPE = LABELS_DATATYPE;
  ADD_LABEL_TITLE = LABELS_ADD_ACTIONPLAN_FORM;
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  tempLabel: LabelPdf = {
    title: "",
    valueType: ""
  };
  validLabel = false;

  addNewLabel() {
    if (this.validLabel) {
      this.$emit(EMIT_ACTION_PLAN_TEMPLATE_EVENTS.ADD_LABEL, this.tempLabel);
    }
  }
  removeLabel(label: LabelPdf) {
    if (this.labelShowList.length != 0) {
      this.$emit(EMIT_ACTION_PLAN_TEMPLATE_EVENTS.REMOVE_LABEL, label);
    }
  }
}
